export default class LspPercentFilter {
  constructor() {
    return function formatPercent(item) {
      return item * 1 >= 0 ? `${item}%` : item;
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-filters/lsp-percent-filter.js